import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = {
  key: 0,
  class: "my-4"
}
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "my-4" }
const _hoisted_5 = { class: "my-4" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "my-4" }
const _hoisted_10 = { class: "my-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "max-width": "720px",
    modelValue: _ctx.shouldShowDialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.shouldShowDialog) = $event)),
    "onClick:outside": _ctx.close
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          (_ctx.targetChild)
            ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.targetChild.lastName) + " " + _toDisplayString(_ctx.targetChild.firstName) + " - " + _toDisplayString(_ctx.creatingData?.time), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            (_ctx.recorder)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("h4", _hoisted_3, "担当スタッフ: " + _toDisplayString(_ctx.recorder.lastName) + " " + _toDisplayString(_ctx.recorder.firstName), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "mb-2" }, "体勢の変更", -1)),
              _createVNode(_component_v_select, {
                variant: "outlined",
                density: "compact",
                items: _ctx.poseOptions,
                "item-value": "value",
                "item-title": "label",
                modelValue: _ctx.pose,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pose) = $event))
              }, null, 8, ["items", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "mb-2" }, "状態", -1)),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (s) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: s.value,
                    class: "mx-2"
                  }, [
                    _createVNode(_component_v_btn, {
                      color: s.color,
                      variant: s.value === _ctx.status ? 'flat' : 'outlined',
                      theme: s.value === _ctx.status ? 'dark' : 'light',
                      value: s.value,
                      onClick: ($event: any) => (_ctx.setStatus(s.value))
                    }, {
                      default: _withCtx(() => [
                        (s.isArrow)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(s.label), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(s.label), 1))
                      ]),
                      _: 2
                    }, 1032, ["color", "variant", "theme", "value", "onClick"])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "mb-2" }, "備考", -1)),
              _createVNode(_component_v_select, {
                variant: "outlined",
                density: "compact",
                multiple: "",
                items: _ctx.noteOptions,
                "item-value": "value",
                "item-title": "label",
                modelValue: _ctx.additionalNote,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.additionalNote) = $event))
              }, null, 8, ["items", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "mb-2" }, "コメント", -1)),
              _createVNode(_component_v_text_field, {
                variant: "outlined",
                density: "compact",
                "hide-details": "",
                modelValue: _ctx.textComment,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.textComment) = $event))
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.isCreating)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 1,
                  indeterminate: "",
                  color: "primary",
                  class: "my-8"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                size: "x-large",
                disabled: _ctx.isCreating,
                onClick: _ctx.create
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("保存", -1)
                ]))]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onClick:outside"]))
}